module.exports = __webpack_public_path__ + "img/20190801162959418.a4b3116f.png";